import React, { useState } from "react";
import {
  Lock,
  Loader2,
  CircleCheckBig,
  CalendarIcon,
  ChevronDown,
  RotateCcw,
  Play,
} from "lucide-react";
import "./TrainingCard.css";

function statusClass(status) {
  return status === "Completed"
    ? "tp-badge-complete"
    : status === "In Progress"
    ? "tp-badge-progress"
    : "tp-badge-scheduled";
}

export default function TrainingCard({
  plan,
  status,
  created,
  duration,
  onOpenSchedule,
  onPlanAction,
  canUseTrainingPlans = true,
}) {
  const isCompleted = status === "Completed";
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="plan-card-wrapper">
        <span className={`plan-status-pill ${statusClass(status)}`}>
  {status === "Not Started" && <Lock size={14} />}
  {status === "In Progress" && <Loader2 size={14} />}
  {status === "Completed" && <CircleCheckBig size={14} />}
  {status}
</span>
    <div
      className={`plan-card ${isCompleted ? "is-completed" : ""}`}
      onClick={() => setExpanded(!expanded)}
    >
      {/* Chevron toggle on left */}
      <div
        className={`plan-card__chevron ${expanded ? "open" : ""}`}
        aria-hidden="true"
      >
        <ChevronDown size={18} />
      </div>

      {/* Main Content */}
      <div className="plan-card__main">
        <div className="plan-card__title-row">
          <h3 className="plan-card__title">{plan.title}</h3>

          {/* Scheduled badge */}
          {plan?.scheduledTime && (
            <span className="scheduled-badge">
              <CalendarIcon size={14} />
              {new Date(plan.scheduledTime).toLocaleString([], {
                dateStyle: "medium",
                timeStyle: "short",
              })}
            </span>
          )}
        </div>

        {/* Show details + meta only if expanded */}
        {expanded && (
          <>
            {plan.details && <p className="plan-card__sub">{plan.details}</p>}
            <div className="plan-card__meta">
              <span>{duration}</span>
              <span className="dot">•</span>
              <span>Created {created}</span>
            </div>
          </>
        )}
      </div>

      {/* Actions */}
      <div
        className="plan-card__actions"
        onClick={(e) => e.stopPropagation()} // prevent toggle when clicking buttons
      >
        {!isCompleted && (
          <button
            className="pm-secondary"
            onClick={() => onOpenSchedule(plan)}
          >
            {plan.scheduledTime ? "Reschedule" : "Schedule"}
          </button>
        )}
        <button
          className={`pm-primary ${isCompleted ? "pm-primary--retry" : ""}`}
          onClick={() => onPlanAction(plan)}
        >
          {!canUseTrainingPlans ? (
            <>
              <Play fill='var(  --input)' size={16} />
              Upgrade
            </>
          ) : isCompleted ? (
            <>
              <RotateCcw size={16} />
              Retry
            </>
          ) : (
            <>
              <Play fill='var(  --input)' size={16} />
              Start
            </>
          )}
        </button>
      </div>
    </div>

    </div>

  );
}
